import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import DashboardAdmin from './pages/DashboardAdmin';
import Logout from './pages/Logout';
import OrganizationsPage from './pages/Organizations.js';
import PointRegister from './pages/PointRegister';
import Reports from './pages/Reports';
import UserManagement from './pages/UserManagement';
import EventsPage from './pages/Events';
import HackathonPage from './pages/HackathonPage';
import PresenceAdminPage from './pages/PresenceAdminPage';
import ParticipantsPage from './pages/ParticipantsPage';
import PointApproval from './pages/PointApproval';
import NotFound from './pages/NotFound';
import AppLayout from './components/AppLayout';
import RequireAuth from './components/RequireAuth';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/hackathon" element={<HackathonPage />} />
        <Route path="/" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route element={<RequireAuth />}>
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<DashboardAdmin />} />
            <Route path="/organizations" element={<OrganizationsPage />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/ponto" element={<PointRegister />} />
            <Route path="/point-approval" element={<PointApproval />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/participantes" element={<ParticipantsPage />} />
            <Route path="/presenca" element={<PresenceAdminPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
